export default {
  // Project
  canCreateProject (user) {
    return user.links.create_project_uri
  },

  canEditProject (project) {
    return project.links.update_uri
  },

  canDeleteProject (project) {
    return project.links.destroy_uri
  },

  canCreatePurchase (project) {
    return project.links.purchase_uri
  },

  // Project memberships role
  is_restricted (membership) {
    return this.is_regular(membership) || (membership.role === 'restricted')
  },

  is_regular (membership) {
    return this.is_administrator(membership) || (membership.role === 'regular')
  },

  is_administrator (membership) {
    return this.is_owner(membership) || (membership.role === 'administrator')
  },

  is_owner (membership) {
    return membership.role === 'owner'
  },

  // Board
  canCreateBoard (project) {
    return project.links.create_board_uri
  },

  canEditBoard (board) {
    return board.links.update_uri
  },

  canDeleteBoard (board) {
    return board.links.destroy_uri
  },

  // Ticket
  // container can be project or board
  canCreateTicket (container) {
    return container.links.create_ticket_uri
  },

  canEditTicket (ticket) {
    return ticket.links.update_uri
  },

  canDeleteTicket (ticket) {
    return ticket.links.destroy_uri
  },

  canWatchTicket (ticket) {
    return ticket.links.create_watch_uri
  },

  canShareTicket (ticket) {
    return ticket.links.create_share_uri
  },

  // Comment
  canCreateComment (ticket) {
    return ticket.links.create_comment_uri
  },

  canEditComment (comment) {
    return comment.links.update_uri
  },

  canDeleteComment (comment) {
    return comment.links.destroy_uri
  },

  canDeleteAttachment (comment) {
    // Same permissions
    return this.canEditComment(comment)
  },

  // Member
  canCreateMember (project) {
    return project.links.create_member_uri
  },

  canEditMember (member) {
    return member.links.update_uri
  },

  canDeleteMember (member) {
    return member.links.destroy_uri
  }

}



// WEBPACK FOOTER //
// ./src/utilities/permissions.js